import $ from 'jquery'
import { debounce, setTransformValue } from '@helpers'

/*
  Product Viewer - 360 deg tour
*/

const productViewer = function (element, direction) {
  this.element = element
  this.handleContainer = this.element.find('.product-viewer-handle')
  this.handleFill = this.handleContainer.children('.fill')
  this.handle = this.handleContainer.children('.handle')
  this.imageWrapper = this.element.find('.product-viewer')
  this.slideShow = this.imageWrapper.children('.product-sprite')
  this.frames = this.element.data('frame')
  //increase this value to increase the friction while dragging on the image - it has to be bigger than zero
  this.friction = this.element.data('friction')
  this.visibleFrame = 0
  this.loaded = false
  this.animating = false
  this.xPosition = 0
  this.direction = direction
  this.loadFrames()
}

productViewer.prototype.loadFrames = function () {
  const self = this
  const imageUrl = this.slideShow.data('image')
  const newImg = $('<img/>')
  this.loading('0.5')

  //you need this to check if the image sprite has been loaded
  newImg
    .attr('src', imageUrl)
    .on('load', function () {
      $(this).remove()
      self.loaded = true
    })
    .each(function () {
      const image = this
      if (image.complete) {
        $(image).trigger('load')
      }
    })

  this.slideShow.css('background-image', `url(${imageUrl})`)
}

productViewer.prototype.loading = function (percentage) {
  const self = this
  setTransformValue(this.handleFill[0], 'scaleX', percentage)
  setTimeout(function () {
    if (self.loaded) {
      //sprite image has been loaded
      self.element.addClass('loaded')
      setTransformValue(self.handleFill[0], 'scaleX', '1')
      self.dragImage()
      if (self.handle) self.dragHandle()
    } else {
      //sprite image has not been loaded - increase self.handleFill scale value
      const newPercentage = parseFloat(percentage) + 0.1
      if (newPercentage < 0.9) {
        self.loading(newPercentage)
      } else {
        self.loading(parseFloat(percentage))
      }
    }
  }, 300)
}

//draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
productViewer.prototype.dragHandle = function () {
  //implement handle draggability
  const self = this
  self.handle
    .on('mousedown vmousedown touchstart', function (e) {
      self.handle.addClass('cd-draggable')
      const dragWidth = self.handle.outerWidth()

      const containerOffset = self.handleContainer.offset().left

      const containerWidth = self.handleContainer.outerWidth()

      const minLeft = containerOffset - dragWidth / 2

      const maxLeft = containerOffset + containerWidth - dragWidth / 2

      if (e.pageX) {
        self.xPosition = self.handle.offset().left + dragWidth - e.pageX
      } else if (e.targetTouches) {
        self.xPosition = self.handle.offset().left + dragWidth - e.targetTouches[0].pageX
      }

      self.element
        .on('mousemove vmousemove touchmove', function (e) {
          self.animating = debounce(!self.animating, self.animating, function () {
            self.animateDraggedHandle(e, dragWidth, containerOffset, containerWidth, minLeft, maxLeft)
          })
        })
        .one('mouseup vmouseup touchend', function () {
          self.handle.removeClass('cd-draggable')
          self.element.off('mousemove vmousemove touchend')
        })

      e.preventDefault()
    })
    .on('mouseup vmouseup touchend', function () {
      self.handle.removeClass('cd-draggable')
    })
}

productViewer.prototype.animateDraggedHandle = function (
  e,
  dragWidth,
  containerOffset,
  containerWidth,
  minLeft,
  maxLeft
) {
  const self = this
  let leftValue
  if (e.pageX) {
    leftValue = e.pageX + self.xPosition - dragWidth
  } else if (e.targetTouches) {
    leftValue = e.targetTouches[0].pageX
    ;+self.xPosition - dragWidth
  }
  // constrain the draggable element to move inside his container
  if (leftValue < minLeft) {
    leftValue = minLeft
  } else if (leftValue > maxLeft) {
    leftValue = maxLeft
  }

  const widthValue = Math.ceil(((leftValue + dragWidth / 2 - containerOffset) * 1000) / containerWidth) / 10
  self.visibleFrame = Math.ceil((widthValue * (self.frames - 1)) / 100)

  self.visibleFrame =
    Math.ceil((widthValue * (self.frames - 1)) / 100) == 0
      ? 0
      : self.frames - Math.ceil((widthValue * (self.frames - 1)) / 100)

  //update image frame
  self.updateFrame()
  //update handle position
  $('.cd-draggable', self.handleContainer)
    .css('left', `${widthValue}%`)
    .one('mouseup vmouseup', function () {
      $(this).removeClass('cd-draggable')
    })

  self.animating = false
}

productViewer.prototype.dragImage = function () {
  //implement image draggability
  const self = this
  self.slideShow
    .on('mousedown vmousedown touchstart', function (e) {
      self.slideShow.addClass('cd-draggable')
      const containerOffset = self.imageWrapper.offset().left

      const containerWidth = self.imageWrapper.outerWidth()

      if (e.pageX) {
        self.xPosition = e.pageX
      } else if (e.targetTouches) {
        self.xPosition = e.targetTouches[0].pageX
      }

      self.element
        .on('mousemove vmousemove touchmove', function (e) {
          self.animating = debounce(!self.animating, self.animating, function () {
            self.animateDraggedImage(e, containerOffset, containerWidth)
          })
        })
        .one('mouseup vmouseup touchend', function () {
          self.slideShow.removeClass('cd-draggable')
          self.element.off('mousemove vmousemove touchend')
          self.updateHandle()
        })

      e.preventDefault()
    })
    .on('mouseup vmouseup touchend', function () {
      self.slideShow.removeClass('cd-draggable')
    })
}

productViewer.prototype.animateDraggedImage = function (e, containerOffset, containerWidth) {
  const self = this
  let leftValue
  if (e.pageX) {
    leftValue = self.xPosition - e.pageX
  } else if (e.targetTouches) {
    leftValue = self.xPosition - e.targetTouches[0].pageX
  }
  const widthValue = Math.ceil((leftValue * 100) / (containerWidth * self.friction))
  let frame = (widthValue * (self.frames - 1)) / 100
  if (frame > 0) {
    frame = Math.floor(frame)
  } else {
    frame = Math.ceil(frame)
  }
  let newFrame = self.visibleFrame + frame

  if (newFrame < 0) {
    newFrame = self.frames - 1
  } else if (newFrame > self.frames - 1) {
    newFrame = 0
  }

  if (newFrame != self.visibleFrame) {
    self.visibleFrame = newFrame
    self.updateFrame()
    if (e.pageX) {
      self.xPosition = e.pageX
    } else if (e.targetTouches) {
      self.xPosition = e.targetTouches[0].pageX
    }
  }

  self.animating = false
}

productViewer.prototype.updateHandle = function () {
  if (this.handle) {
    const widthValue = this.visibleFrame == 0 ? 0 : (100 * (this.frames - this.visibleFrame)) / this.frames

    this.handle.animate({ left: `${widthValue}%` }, 200)
  }
}

productViewer.prototype.updateFrame = function () {
  let frame = this.visibleFrame

  if (this.direction == 'ccw') {
    frame = this.frames - 1 - this.visibleFrame
  }

  const transformValue = -((100 * frame) / this.frames)

  setTransformValue(this.slideShow[0], 'translateX', `${transformValue}%`)
}

function initProductViewer(trigger) {
  const selectedProductViewer = $(`#${trigger.data('vt')}`)
  if (selectedProductViewer.hasClass('product-viewer-wrapper')) return
  selectedProductViewer.addClass('product-viewer-wrapper')
  new productViewer(selectedProductViewer)
}

/*
  Product Viewer Triggers
*/
const productViewerTriggers = $('.trigger-exterior-vt')
if (productViewerTriggers.length > 0) {
  productViewerTriggers.on('click', function (event) {
    event.preventDefault()
    initProductViewer($(this))
  })
}

export { productViewer, initProductViewer }
export default productViewer
